<template>
  <div class="image-search">
    <!-- Thanh tìm kiếm -->
    <div class="search-bar">
      <input type="text" v-model="searchQuery" placeholder="Dán link hoặc tải hình ảnh lên" @paste="handlePaste"
        @keydown.enter="searchImage" />
      <label class="button" for="fileUpload">Tải ảnh</label>
      <v-file-input id="fileUpload" v-model="uploadFile" ref="fileInput" @change="handleFileUpload" accept="image/png, image/jpeg, image/bmp" hide-input prepend-icon="">
      </v-file-input>
    </div>

    <!-- Kết quả tìm kiếm -->
    <div class="search-results">
      <div v-if="searchResults.length === 0" class="no-results">
        Không có kết quả tìm kiếm.
      </div>
      <div class="image-grid"  v-viewer="options">
        <div v-for="(image, index) in searchResults" :key="index" class="image-item">
          <img :src="image.path" alt="Kết quả tìm kiếm" style="width: 188px; height: 234px;"/>
          <a :href="'/quan-ly-san-pham/'+image.product_id" target="_blank">{{ image.product_code }}</a>
          <p>Độ chính xác: {{ image.similarity | currency('', 6) }}</p>
        </div>
      </div>
    </div>
    <v-overlay :value="loading" z-index="999999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      options: {
          inline: false,
          button: true,
          navbar: true,
          title: 2,  // show if screen > 768px
          toolbar: {
          zoomIn: 1,
          zoomOut: 1,
          oneToOne: 1,
          reset: 1,
          prev: 1,
          play: {
              show: 1,
              size: 'large',
          },
          next: 1,
          rotateLeft: 1,
          rotateRight: 1,
          flipHorizontal: 1,
          flipVertical: 1,
          },
          tooltip: true,
          movable: true,
          zoomable: true,
          rotatable: true,
          scalable: true,
          transition: true,
          fullscreen: true,
          keyboard: true,
      },
      searchQuery: "", // Lưu trữ link hoặc text tìm kiếm
      uploadFile: null
    };
  },
  computed: {
      ...mapState({
          loading: state => state.images.loading,
          searchResults: state => state.images.image_results
      }),
      modifyId() {
          return this.$route.params.Pid;
      }
  },
  methods: {
    // Xử lý khi tải ảnh lên từ file
    handleFileUpload(event) {
      const file = this.uploadFile;
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.searchImage(e.target.result); // Gửi ảnh base64 để tìm kiếm
        };
        reader.readAsDataURL(file);
      }
    },
    // Xử lý khi người dùng paste hình ảnh từ clipboard
    handlePaste(event) {
      const clipboardData = event.clipboardData;
      const items = clipboardData.items;
      for (let item of items) {
        if (item.type.startsWith("image/")) {
          this.uploadFile = item.getAsFile();
          const reader = new FileReader();
          reader.onload = (e) => {
            this.searchImage(e.target.result); // Gửi ảnh base64 để tìm kiếm
          };
          reader.readAsDataURL(this.uploadFile);
          return;
        }
      }
      // Nếu không phải ảnh, tìm kiếm bằng văn bản
      this.searchImage(this.searchQuery);
    },
    // Tìm kiếm hình ảnh (mock API hoặc tích hợp API thực tế)
    searchImage(imageOrQuery) {
      console.log("Đang tìm kiếm với:", imageOrQuery);
      let formData = new FormData();
      formData.append(`images[]`, this.uploadFile);
      this.$store.dispatch("images/search_media_file", formData);
    },
  },
};
</script>

<style scoped>
.image-search {
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
}

.search-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.search-bar input[type="text"] {
  width: 60%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-right: 10px;
}

.search-bar .button {
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.search-bar .button:hover {
  background-color: #0056b3;
}

.search-results {
  margin-top: 20px;
}

.no-results {
  color: #666;
}

.image-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
}

.image-item img {
  width: 100%;
  border-radius: 5px;
  border: 1px solid #ccc;
}

@media (max-width: 768px) {
  .image-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }
}
</style>